import React, { useEffect, useState } from 'react';
import { Button, Icon } from '@iwoca/orion';
import { t } from '@lingui/macro';
import clsx from 'clsx';
import { ListFilter } from 'components/ListFilter/ListFilter';
import { useAmplitude } from 'hooks/useAmplitude';
import { TNotificationSubscription } from 'lendingApi/notifications';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import {
  SUBSCRIPTIONS,
  getSubscriptionsUpdateData,
} from './NotificationSettings.helpers';
import styles from './NotificationSettings.module.css';

type TProps = {
  show: boolean;
  onBackClick: () => void;
  subscriptions?: TNotificationSubscription[];
  isUpdatingSubscriptions: boolean;
  updateSubscriptions: (subscriptions: TNotificationSubscription[]) => void;
};

export const NotificationSettings = ({
  show,
  onBackClick,
  subscriptions = [],
  isUpdatingSubscriptions,
  updateSubscriptions,
}: TProps) => {
  const { trackEvent } = useAmplitude();
  const [values, setValues] = useState<string[]>([]);

  useEffect(() => {
    setValues(
      subscriptions
        .filter((item) => item.subscribed)
        .map((item) => item.status),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(subscriptions)]);

  const handleSave = (selectedValues: string[]) => {
    updateSubscriptions(
      getSubscriptionsUpdateData(subscriptions, selectedValues),
    );

    trackEvent(AMPLITUDE_EVENTS.notificationsFiltered, {
      'Selected filters': selectedValues.toString(),
    });
  };

  return (
    <div
      className={clsx(styles.settingsWrapper, {
        [styles.show]: show,
      })}
    >
      <Button
        onClick={onBackClick}
        className={styles.backButton}
        size="small"
        variant="tertiary"
      >
        <Icon icon="arrowLeft" fontSize="1.2rem" />
        {t`Back`}
      </Button>
      <div className={styles.content}>
        <ListFilter
          variant="normal"
          title={t`Filter notifications`}
          values={values}
          disableSaveUntilChanged
          items={SUBSCRIPTIONS()}
          onSave={handleSave}
          isLoading={isUpdatingSubscriptions}
        />
      </div>
    </div>
  );
};
